import React from 'react'

export default function Loader() {
  return (
      <img className='animate-pulse' src="/images/DystoPunks_Logo.png" alt="loading" width="257" height="87" />
  )
}
